import { useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextareaAutosize, TextField } from '@mui/material';
import { DatePicker, DateTimePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CoachAPI } from '../../../api/CoachAPI.js';
import Loader from "../../../component/Loader.jsx";
import { useSelector } from 'react-redux';
import { isUser, isGuest } from '../../../util/UserRoles.js';
import { FormTemplateAPI } from '../../../api/FormTemplateAPI.js';
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog.jsx';
import dayjs from 'dayjs';
import * as Yup from 'yup';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI.js';
import { Privileges } from '../../../util/PrivilegeConstants.js';
import { SeasonStatus } from '../../../util/SeasonStatus.js';
import EventDataCard from './EventDataCard.jsx';
import CustomSwitch from '../../CustomComponents/CustomSwitch/CustomSwitch.jsx';
import { EventAPI } from '../../../api/EventAPI.js';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { Timezone } from "@syncfusion/ej2-react-schedule";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { EditorOption } from './EditorOption.js';

const initialValue = {
    eventName: '',
    description: '',
    startDate: null,
    endDate: null,
    eventDate: null,
    autoCloseTime: dayjs(new Date()),
    endTime: dayjs().minute(0).second(0).add(1, 'hour'),
    startTime: dayjs().minute(0).second(0),
    formTemplateId: '',
    autoClose: false,
    resourceId: null,
    isOpenForGuest: false,
    isPlanReplaceable: true,
    status: SeasonStatus.ACTIVE,
    guestRegGuideLine: null,
    isEmailDispatch: false
}

dayjs.extend(utc);
dayjs.extend(timezone);
const validationObj1 = Yup.object({
    eventName: Yup.string().required("Event Name is required"),
    eventType: Yup.string().required("Event Type is required"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
    formTemplateId: Yup.string().required("Please select one form template"),
    description: Yup.string().max(2000, "Maximum 2000 characters"),
});

const validationObj2 = Yup.object({
    eventName: Yup.string().required("Event Name is required"),
    eventType: Yup.string().required("Event Type is required"),
    eventDate: Yup.string().required("Event Date is required"),
    formTemplateId: Yup.string().required("Please select one form template"),
    description: Yup.string().max(2000, "Maximum 2000 characters"),
});
const EventList = () => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [openDialog, setOpenDialog] = useState({ isOpen: false, isEdit: false });
    const [data, setData] = useState(initialValue);
    const [isLoading, setIsLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const [children, setChildren] = useState([]);
    const [formTemplates, setFormTemplates] = useState([]);
    const [fieldErrors, setFieldErrors] = useState({});
    const [privileges, setPrivileges] = useState({});
    const [games, setGames] = useState([]);
    const [eventStatus, setEventStatus] = useState(SeasonStatus.REGISTRATION_OPENED)

    const [isSingleEvent, setIsSingleEvent] = useState(false)
    let eventStatusList = [];

    const getFormattedDate = (date) => {
        if (!date) return null;
        if (typeof date === 'string') {
            return date;
        } else {
            return `${date.$y}-${String(Number(date.$M) + 1).padStart(2, '0')}-${String(date.$D).padStart(2, '0')}`;
        }
    }


    const handleCollectData = (event) => {
        // console.log("hadle collected data", event.target.name);

        const { name, value } = event.target;
        setData({ ...data, [name]: value });
    }
    const clearAllState = () => {
        setData(initialValue);
        setFieldErrors({});
    }

    const handleOpenEditSeasonPopup = (eventData) => {
        const updatedData = {
            ...eventData,
            description: eventData.eventDesc,
            isEmailDispatch: false,
        };

        setData(updatedData);
        setOpenDialog({ isOpen: true, isEdit: true });
    };
    // console.log(data);



    const convertIntoLocalTimezone = (time) => {
        const combinedDateTime = dayjs(data.eventDate)
            .hour(time.hour())
            .minute(time.minute())
            .second(time.second())
            .millisecond(0);
        let timezone = new Timezone();
        return timezone.removeLocalOffset(new Date(combinedDateTime))
    };

    const handleCreateEvent = async () => {
        try {
            if (isSingleEvent) {
                await validationObj2.validate(data, { abortEarly: false });
            } else {
                await validationObj1.validate(data, { abortEarly: false });
            }
            const date = new Date(data.eventDate);
            const year = date.getFullYear();
            const month = `0${date.getMonth() + 1}`.slice(-2);
            const day = `0${date.getDate()}`.slice(-2);
            const formattedDate = `${year}-${month}-${day}`;
            const reqData = {
                eventName: data?.eventName?.trim(),
                eventType: data.eventType,
                eventDesc: data.description?.trim(),
                startDate: getFormattedDate(data.startDate),
                endDate: getFormattedDate(data.endDate),
                eventDate: getFormattedDate(data.eventDate),
                createdBy: userInfo.userId,
                formTemplateId: data.formTemplateId,
                clubId: selectedClub?.clubId,
                autoClose: data.autoClose,
                isPlanReplaceable: data.isPlanReplaceable,
                autoCloseTime: data.autoClose ? data.autoCloseTime : null,
                status: data.status || SeasonStatus.ACTIVE,
                // startTime: data.startTime.format("HH:mm:ss"),
                // endTime: data.endTime.format("HH:mm:ss"),
                startTime: convertIntoLocalTimezone(data.startTime),
                endTime: convertIntoLocalTimezone(data.endTime),
                resourceId: data.resourceId,
                isOpenForGuest: data.isOpenForGuest,
                guestRegGuideLine: data.guestRegGuideLine
            }

            setIsLoading(true)
            await EventAPI.postCreateEvent(reqData);
            setOpenDialog({ isOpen: false, isEdit: false });
            clearAllState();
            setIsUpdate(true)
        } catch (error) {
            console.error(error);
            if (error?.inner) {
                let errObj = {};
                error.inner.forEach(err => {
                    errObj[err.path] = err.message
                })
                setFieldErrors(errObj);
            }
        } finally {
            setIsLoading(false);
        }
    }
    const handleEditEvent = async () => {
        try {
            if (isSingleEvent) {
                await validationObj2.validate(data, { abortEarly: false });
            } else {
                await validationObj1.validate(data, { abortEarly: false });
            }
            const reqData = {
                eventId: data.eventId,
                clubId: selectedClub.clubId,
                eventName: data?.eventName?.trim(),
                eventType: data.eventType,
                eventDate: isSingleEvent ? getFormattedDate(data.eventDate) : null,
                eventDesc: data.description?.trim(),
                startDate: !isSingleEvent ? getFormattedDate(data.startDate) : null,
                endDate: !isSingleEvent ? getFormattedDate(data.endDate) : null,
                autoClose: data.autoClose,
                isPlanReplaceable: data.isPlanReplaceable,
                autoCloseTime: data.autoClose ? data.autoCloseTime : null,
                formTemplateId: data.formTemplateId,
                status: data.status,
                isOpenForGuest: data.isOpenForGuest,
                guestRegGuideLine: data.guestRegGuideLine,
                isEmailDispatch: data.isEmailDispatch
            }

            setIsLoading(true)
            await EventAPI.putUpdateEvent(reqData);
            setOpenDialog({ isOpen: false, isEdit: false });
            clearAllState();
            setIsUpdate(true)
        } catch (error) {
            console.error(error);
            if (error?.inner) {
                let errObj = {};
                error.inner.forEach(err => {
                    errObj[err.path] = err.message
                })
                setFieldErrors(errObj);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const findAllEventData = async (status) => {
        try {
            setIsLoading(true);
            const response = await EventAPI.getAllEvent(selectedClub?.clubId, status);
            setEvents(response.Data);
        } catch (error) {
            console.log("Error: " + error);

        } finally {
            setIsLoading(false);
        }
    }

    const getFormTemplates = async () => {
        try {
            setIsLoading(true)
            const response = await FormTemplateAPI.getAllApprovedFormTemplate(selectedClub.clubId);
            setFormTemplates(response.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const findAllChildren = async () => {
        try {
            const response = await CoachAPI.findAllChildren(userInfo?.userId);
            setChildren(response.Data);
        } catch (error) {
            console.error(error);
        }
    }
    const findAllPrivileges = async () => {
        try {
            setIsLoading(true)
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[12]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (selectedClub.clubId) {
            getFormTemplates();
        }
    }, [selectedClub.clubId])
    useEffect(() => {
        if (userInfo.userId) {
            findAllPrivileges();
        }
    }, [userInfo.userId])
    useEffect(() => {
        if (userInfo.userId) {
            findAllEventData(eventStatus);
            findAllChildren();
        }
        isUpdate && setIsUpdate(false);
    }, [userInfo.userId, selectedClub.clubId, isUpdate]);

    const handleEventStatusChange = (event) => {
        findAllEventData(event.target.value);
        setEventStatus(event.target.value);
    };

    if (userInfo.userId) {
        if (isGuest(userInfo) || isUser(userInfo)) {
            eventStatusList = [
                SeasonStatus.ACTIVE,
                SeasonStatus.REGISTRATION_CLOSED,
                SeasonStatus.REGISTRATION_OPENED
            ]
        } else {
            eventStatusList = [
                SeasonStatus.ACTIVE,
                SeasonStatus.REGISTRATION_CLOSED,
                SeasonStatus.REGISTRATION_OPENED,
                SeasonStatus.DISABLED
            ]
        }
    }


    const getTitleByStatus = (status) => {
        switch (status) {
            case SeasonStatus.ACTIVE:
                return "Upcoming";
            case SeasonStatus.REGISTRATION_OPENED:
                return "Registration Open";
            case SeasonStatus.REGISTRATION_CLOSED:
                return "Registration Closed";
            case SeasonStatus.DISABLED:
                return "Disabled";
            default:
                return "";
        }
    };
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 16 }, (_, i) => currentYear + i);

    return (
        <div className='sm_season_list_container'>
            {isLoading && <Loader />}
            <div className='sm_season_list_header'>
                <h1>Events</h1>
                <div className='sm_season_list_btn_con'>
                    <FormControl error={fieldErrors['status']}
                        fullWidth data-testid="game-dropdown"
                        className='sm_season_form_template_input' >
                        <InputLabel sx={{ top: '0px' }} id="demo-simple-select-autowidth-label">Status</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={eventStatus || ''}
                            onChange={handleEventStatusChange}
                            fullWidth
                            label="Status"
                            name='status'
                            size='small'
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 200, // ⬅️ controls total dropdown height
                                    },
                                },
                                MenuListProps: {
                                    sx: {
                                        paddingY: 0, // ⬅️ removes extra vertical padding in the list
                                    },
                                },
                            }}
                        >
                            {
                                eventStatusList.map((item, index) =>
                                    <MenuItem sx={{ textTransform: 'capitalize' }} key={index} value={item}>{getTitleByStatus(item)}</MenuItem>
                                )}
                        </Select>
                        {
                            fieldErrors['status'] &&
                            <FormHelperText sx={{ color: 'red', m: 0 }} >{fieldErrors['status']}</FormHelperText>
                        }
                    </FormControl>
                    {privileges?.MANAGE_EVENT?.includes(Privileges.CREATE) &&
                        <button onClick={() => {
                            if (games.length > 0) {
                                setData(prev => ({ ...prev, gameId: games[0].gameId }));
                            }
                            setOpenDialog({ isOpen: true, isEdit: false })
                        }}>
                            Add Event
                        </button>}
                </div>
            </div>
            {events?.length != 0 ?
                <div className='sm_season_card_list'>
                    {events?.map((event, index) =>
                        ((isUser(userInfo) || isGuest(userInfo)) && event?.status === SeasonStatus.DISABLED) ?
                            <></> :
                            <EventDataCard
                                key={index}
                                children={children}
                                event={event}
                                userInfo={userInfo}
                                handleOpenEditSeasonPopup={handleOpenEditSeasonPopup}
                                privileges={privileges}
                                index={index}
                            />
                    )}
                </div>
                :
                <div className='sm_join_request_not_found' style={{ minHeight: '60dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <p>The field is wide open. Create your first event to get the season rolling!</p>
                </div>}
            <CustomDialog
                title="Enter Event Details"
                isOpen={openDialog.isOpen}
                onCancel={() => {
                    setOpenDialog({ isOpen: false, isEdit: openDialog.isEdit });
                    clearAllState();
                }}
                onClose={() => setOpenDialog({ isOpen: false, isEdit: openDialog.isEdit })}
                onSubmit={openDialog.isEdit ? handleEditEvent : handleCreateEvent}
                submitBtnName={openDialog.isEdit ? 'Save' : 'Create'}
            >
                <div className="sm_add_event_form">
                    <TextField fullWidth
                        className="add-member-text-input"
                        error={fieldErrors['eventName']}
                        helperText={fieldErrors['eventName'] && fieldErrors['eventName']}
                        variant="outlined"
                        value={data.eventName || ''}
                        onChange={handleCollectData}
                        label='Event Name *'
                        name='eventName'
                        FormHelperTextProps={{
                            sx: {
                                margin: 0,
                            }
                        }}
                    />
                    <div style={{ display: 'flex', gap: 10 }}>
                        <FormControl error={fieldErrors['eventType']}
                            fullWidth data-testid="game-dropdown"
                            className='sm_season_form_template_input' >

                            <InputLabel id="demo-simple-select-autowidth-label">Event Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={data.eventType || ''}
                                onChange={handleCollectData}
                                fullWidth
                                label="Event Type"
                                name='eventType'
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 200, // ⬅️ controls total dropdown height
                                        },
                                    },
                                    MenuListProps: {
                                        sx: {
                                            paddingY: 0, // ⬅️ removes extra vertical padding in the list
                                        },
                                    },
                                }}
                            >

                                <MenuItem value="SEASON">Season</MenuItem>
                                <MenuItem value="MEET">Meet</MenuItem>

                            </Select>
                            {
                                fieldErrors['eventType'] &&
                                <FormHelperText sx={{ color: 'red', m: 0 }} >{fieldErrors['eventType']}</FormHelperText>
                            }
                        </FormControl>

                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <FormControl error={fieldErrors['formTemplateId']}
                            fullWidth data-testid="game-dropdown"
                            className='sm_season_form_template_input' >

                            <InputLabel required id="demo-simple-select-autowidth-label">Form template</InputLabel>
                            <Select
                                disabled={(data?.playerIds?.length != 0 && openDialog.isEdit)}
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={data.formTemplateId || ''}
                                onChange={handleCollectData}
                                fullWidth
                                label="Form template"
                                name='formTemplateId'
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 200, // ⬅️ controls total dropdown height
                                        },
                                    },
                                    MenuListProps: {
                                        sx: {
                                            paddingY: 0, // ⬅️ removes extra vertical padding in the list
                                        },
                                    },
                                }}
                            >
                                {formTemplates?.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item?.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            {
                                fieldErrors['formTemplateId'] &&
                                <FormHelperText sx={{ color: 'red', m: 0 }} >{fieldErrors['formTemplateId']}</FormHelperText>
                            }
                        </FormControl>

                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                            <FormControl error={fieldErrors['status']}
                                fullWidth data-testid="season-status"
                                className='sm_season_form_template_input' >

                                <InputLabel id="demo-simple-select-autowidth-label">Status</InputLabel>
                                <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={data.status || SeasonStatus.ACTIVE}
                                    onChange={handleCollectData}
                                    fullWidth
                                    label="Status"
                                    name='status'
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                maxHeight: 200, // ⬅️ controls total dropdown height
                                            },
                                        },
                                        MenuListProps: {
                                            sx: {
                                                paddingY: 0, // ⬅️ removes extra vertical padding in the list
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value={SeasonStatus.ACTIVE}>Draft</MenuItem>
                                    <MenuItem value={SeasonStatus.REGISTRATION_OPENED}>Open</MenuItem>
                                    <MenuItem value={SeasonStatus.REGISTRATION_CLOSED}>Closed</MenuItem>
                                    <MenuItem value={SeasonStatus.DISABLED}>Disabled</MenuItem>
                                </Select>
                                {
                                    fieldErrors['status'] &&
                                    <FormHelperText sx={{ color: 'red', m: 0 }} >{fieldErrors['status']}</FormHelperText>
                                }
                            </FormControl>

                        </div>

                    <div className='sm_event_auto_close_con'>
                        <CustomSwitch checked={isSingleEvent} onChange={(e) => setIsSingleEvent(e.target.checked)} />
                        <p>Is Single Event </p>
                    </div>
                    {isSingleEvent ?
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                className="date_picker"
                                value={dayjs(data.eventDate)}
                                onChange={(date) => handleCollectData({ target: { name: 'eventDate', value: date } })}
                                label="Event Date *"
                                sx={{ width: "100%" }}
                            />
                        </LocalizationProvider>
                        :
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="date_picker"
                                    value={dayjs(data.startDate)}
                                    onChange={(date) => handleCollectData({ target: { name: 'startDate', value: date } })}
                                    label="Start Date *"
                                    sx={{ width: "100%" }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="date_picker"
                                    value={dayjs(data.endDate)}
                                    onChange={(date) => handleCollectData({ target: { name: 'endDate', value: date } })}
                                    label="End Date *"
                                    sx={{ width: "100%" }}
                                />
                            </LocalizationProvider>
                        </div>}

                    {/* {!openDialog.isEdit  &&
                    <div className='sm_event_auto_close_con'>
                        <CustomSwitch checked={isScheduleCreate} onChange={(e) => setIsScheduleCreate(e.target.checked)} />
                        <p>Is create schedule </p>
                    </div>} */}
                    {/* {(!openDialog.isEdit && isScheduleCreate) &&
                        <>
                            <h3>Schedule Details</h3>
                            {courtList.length != 0 &&
                                <div className="member-name-input">
                                    <FormControl error={fieldErrors['gameId']}
                                        fullWidth data-testid="game-dropdown"
                                        className='sm_season_form_template_input' >

                                        <InputLabel id="demo-simple-select-autowidth-label">Game</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={data.gameId || ''}
                                            onChange={(e) => {
                                                handleCollectData(e)
                                                handleChangeGameData(e.target.value);
                                            }
                                            }
                                            fullWidth
                                            label="Game"
                                            name='gameId'
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        maxHeight: 200, // ⬅️ controls total dropdown height
                                                    },
                                                },
                                                MenuListProps: {
                                                    sx: {
                                                        paddingY: 0, // ⬅️ removes extra vertical padding in the list
                                                    },
                                                },
                                            }}
                                        >
                                            {games?.map((item) => (
                                                <MenuItem key={item.gameId} value={item.gameId}>
                                                    {item?.gameName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {
                                            fieldErrors['gameId'] &&
                                            <FormHelperText sx={{ color: 'red', m: 0 }} >{fieldErrors['gameId']}</FormHelperText>
                                        }
                                    </FormControl>
                                    <FormControl error={fieldErrors['resourceId']}
                                        fullWidth data-testid="game-dropdown"
                                        className='sm_season_form_template_input' >

                                        <InputLabel id="demo-simple-select-autowidth-label">Court No</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={data.resourceId || ''}
                                            onChange={handleCollectData}
                                            fullWidth
                                            label="Court No"
                                            name='resourceId'
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        maxHeight: 200, // ⬅️ controls total dropdown height
                                                    },
                                                },
                                                MenuListProps: {
                                                    sx: {
                                                        paddingY: 0, // ⬅️ removes extra vertical padding in the list
                                                    },
                                                },
                                            }}
                                        >
                                            {courtList?.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item?.courtNumber}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {
                                            fieldErrors['resourceId'] &&
                                            <FormHelperText sx={{ color: 'red', m: 0 }} >{fieldErrors['resourceId']}</FormHelperText>
                                        }
                                    </FormControl>
                                </div>}
                            <div className="member-name-input">

                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <TimePicker
                                        className="date_picker"
                                        value={dayjs(data.startTime)}
                                        onChange={(date) => handleCollectData({ target: { name: 'startTime', value: date } })}
                                        label="Start Time *"
                                        sx={{ width: "100%" }}
                                    />
                                </LocalizationProvider>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <TimePicker
                                        className="date_picker"
                                        value={dayjs(data.endTime)}
                                        onChange={(date) => handleCollectData({ target: { name: 'endTime', value: date } })}
                                        label="End Time *"
                                        sx={{ width: "100%" }}
                                    />
                                </LocalizationProvider>

                            </div>

                        </>
                    } */}

                    <div className='sm_event_auto_close_con'>
                        <CustomSwitch checked={data.isPlanReplaceable} onChange={(e) => handleCollectData({ target: { name: 'isPlanReplaceable', value: e.target.checked } })} />
                        <p>Plan replacement</p>
                    </div>
                    {/* <div className='sm_event_auto_close_con'>
                        <CustomSwitch checked={data.autoClose} onChange={(e) => handleCollectData({ target: { name: 'autoClose', value: e.target.checked } })} />
                        <p>Automatically close registration on specified date</p>
                    </div>
                    {data?.autoClose &&
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                className="date_picker"
                                value={data.autoCloseTime ? dayjs(data.autoCloseTime) : dayjs(new Date())}
                                onChange={(date) => handleCollectData({ target: { name: 'autoCloseTime', value: date } })}
                                label="Registration Close Date *"
                                sx={{ width: "100%" }}
                            />
                        </LocalizationProvider>} */}

                    <div className='sm_event_guideline_text_editor'>
                        <h5>Provide Event Description</h5>
                        <ReactQuill formats={EditorOption.formats} modules={EditorOption.modules} theme="snow" className="editor-input"
                            value={data.description}
                            onChange={value => setData(d => ({ ...d, description: value }))}
                        />
                    </div>

                    <div className='sm_event_auto_close_con'>
                        <CustomSwitch checked={data.isOpenForGuest} onChange={(e) => handleCollectData({ target: { name: 'isOpenForGuest', value: e.target.checked } })} />
                        <p>Open for guests</p>
                    </div>
                    {data.isOpenForGuest &&
                        <div className='sm_event_guideline_text_editor'>
                            <h5>Provide Registration Guidelines</h5>
                            <ReactQuill formats={EditorOption.formats} modules={EditorOption.modules} theme="snow" className="editor-input" value={data.guestRegGuideLine} onChange={(e) => handleCollectData({ target: { name: 'guestRegGuideLine', value: e } })} />
                        </div>}
                    {openDialog?.isEdit &&
                        <div className='sm_event_auto_close_con'>
                            <CustomSwitch checked={data.isEmailDispatch} onChange={(e) => handleCollectData({ target: { name: 'isEmailDispatch', value: e.target.checked } })} />
                            <p>Is dispatch email ?</p>
                        </div>}
                </div>
            </CustomDialog>
        </div>
    )
}
export default EventList